import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Breadcrumb from './Breadcrumb';

export default class Breadcrumbs extends Component {
    static propTypes = {
        className: PropTypes.string,
        items: PropTypes.arrayOf(
            PropTypes.shape({
                className: PropTypes.string,
                label: PropTypes.string,
                link: PropTypes.string,
                active: PropTypes.bool,
                icon: PropTypes.string,
            })
        ),
        children: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.arrayOf(PropTypes.element),
        ]),
    };

    constructor(props) {
        super(props);

        const {items, children} = props;

        if (items && children) {
            throw new Error(
                'Breadcrumbs should only be composed of an items array or Breadcrumb elements, never both.'
            );
        }
    }

    _renderItems() {
        const {items, children} = this.props;

        if (items) {
            return items.map((item, i) => {
                const {className, label, link, icon, active} = item;

                return (
                    <Breadcrumb
                        key={i}
                        className={className}
                        label={label}
                        link={link}
                        icon={icon}
                        active={active}
                    />
                );
            });
        } else {
            return children;
        }
    }

    render() {
        const classes = classNames('Breadcrumbs', this.props.className);

        return <ul className={classes}>{this._renderItems()}</ul>;
    }
}
